import { t } from "i18next";

import TitledPage from "@/modules/common/components/layout/pages/TitledPage";

const ModulesPage = () => {
  return <TitledPage title={t("Admin Modules")}></TitledPage>;
};

export default ModulesPage;
